import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { PageViewConsumer } from 'apps/analytics/components/PageView';
import dynamicYieldService from '../services/DynamicYieldService';
import { PageContextType } from '../consts';

function DynamicYieldPageContext({ customerNum, type, data, pageView }) {
  useEffect(() => {
    dynamicYieldService.reportPageContext({ type, data });
  }, [type, data]);

  useEffect(() => {
    dynamicYieldService.reportLoginEvent(customerNum, pageView.isJustLoggedIn);
  }, [customerNum]);

  return null;
}

DynamicYieldPageContext.propTypes = {
  customerNum: PropTypes.string,
  type: PropTypes.string.isRequired,
  data: PropTypes.array,
};

DynamicYieldPageContext.defaultProps = {
  type: PageContextType.OTHER,
};

export default (props) => (
  <PageViewConsumer>
    {(context) => <DynamicYieldPageContext {...context} {...props} />}
  </PageViewConsumer>
);
